import axios from "axios";
import apiConfig from "../config/apiConfig";

const businessApiInstance = axios.create({
  baseURL: apiConfig.endpoints.businessService.baseURL,
  timeout: 15000,
});

const convertToFormData = (data) => {
  const formData = new FormData();

  Object.keys(data).forEach((key) => {
    const value = data[key];

    if (value === null || value === undefined) return;

    if (key === "logo" && value instanceof File) {
      formData.append("logo", value);
      return;
    }

    if (Array.isArray(value)) {
      formData.append(key, JSON.stringify(value));
      return;
    }

    formData.append(key, value);
  });

  return formData;
};

const createBusiness = async (body) => {
  try {
    const dataToSend = convertToFormData(body);

    const response = await businessApiInstance.post(
      apiConfig.endpoints.businessService.routes.createBusiness,
      dataToSend,
      {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      }
    );

    return response.data ?? response;
  } catch (error) {
    return error.response?.data ?? error;
  }
};

const getBusiness = async (params = {}) => {
  try {
    const response = await businessApiInstance.get(
      apiConfig.endpoints.businessService.routes.getBusiness,{ params }
    );
    return response.data;
  } catch (error) {
    return error.response?.data ?? error;
  }
};

const getCategories = async () => {
  try {
    const response = await businessApiInstance.get(
      apiConfig.endpoints.businessService.routes.getCategories
    );
    return response.data;
  } catch (error) {
    return error.response?.data ?? error;
  }
};

const getServices = async () => {
  try {
    const response = await businessApiInstance.get(
      apiConfig.endpoints.businessService.routes.getServices
    );
    return response.data;
  } catch (error) {
    return error.response?.data ?? error;
  }
};

const getServicesByCategory = async (categoryId) => {
  const route =
    apiConfig.endpoints.businessService.routes.getServicesByCategory.replace(
      ":categoryId",
      categoryId
    );

  try {
    const response = await businessApiInstance.get(route);
    return response.data;
  } catch (error) {
    return error.response?.data ?? error;
  }
};

const businessApi = {
  createBusiness,
  getBusiness,
  getCategories,
  getServices,
  getServicesByCategory
};

export default businessApi;
